import React from "react";
// import Navbar from "./Navbar";
import MainNavbar from "./MainNavbar";
import { Footer } from "./Footer";

import img1 from "../assets/images/Trade/Screenshot from 202.png"
import img2 from "../assets/images/Trade/Screenshot from 203.png"
import img3 from "../assets/images/Trade/Screenshot from 204.png"
import img4 from "../assets/images/Trade/Screenshot from 205.png"
import img5 from "../assets/images/Trade/Screenshot from 206.png"
import img6 from "../assets/images/Trade/Screenshot from 207.png"
import img7 from "../assets/images/Trade/Screenshot from 208.png"
import img8 from "../assets/images/Trade/Screenshot from 209.png"
import img9 from "../assets/images/Trade/Screenshot from 210.png"




export const Trade = () => {
    return (
        <>
            <div className="w-full bg-white">
                {/* <Navbar /> */}
                <MainNavbar />
                <div className="text-center pt-20">
                    <div className="m-auto w-[50%]">
                        <img src={img1} />
                    </div>
                    <div className="m-auto w-[50%]">
                        <img src={img2} />
                    </div>
                    <div className="m-auto w-[50%]">
                        <img src={img3} />
                    </div>
                    <div className="m-auto w-[50%]">
                        <img src={img4} />
                    </div>
                    <div className="m-auto w-[50%]">
                        <img src={img5} />
                    </div>
                    <div className="m-auto w-[50%]">
                        <img src={img6} />
                    </div>
                    <div className="m-auto w-[50%]">
                        <img src={img7} />
                    </div>
                    <div className="m-auto w-[50%]">
                        <img src={img8} />
                    </div>
                    <div className="m-auto w-[50%]">
                        <img src={img9} />
                    </div>
                </div>
                <Footer />
            </div>
            
        </>
    )
}